<template>
  <layout-card-wrap hasHeaderSlot
                    style="margin-top: 15px"
                    v-loading="loading">
    <template slot="title">账号信息</template>
    <div slot="form">
      <el-popover v-if="userInfo.isAdmin === 1" title="设置"
        :width="100"
        placement="top"
        trigger="click">
        <el-switch
          :width="60"
          @change="changeDataScope"
          :value="staffProductDataScope"
          :active-value="1"
          :inactive-value="0"
          active-text="启用"
          inactive-text="禁用">
        </el-switch>
        <el-button :type="staffProductDataScope === 1 ? 'success' : 'info'" slot="reference">商品范围权限({{ staffProductDataScope === 1 ? '已启用' : '已禁用' }})</el-button>
      </el-popover>
      <el-button type="primary"
                 style="margin-left: 10px"
                 @click="additem"
                 :loading="loading">新增</el-button>
    </div>
    <el-table border
              stripe
              :data="list">
      <el-table-column label="账号"
                       prop="account">
      </el-table-column>
      <el-table-column label="员工姓名"
                       prop="staffName">
      </el-table-column>
      <el-table-column label="手机号码"
                       prop="mobile">
      </el-table-column>
      <!-- <el-table-column label="邮箱"
                       width="160"
                       prop="email">
      </el-table-column> -->
      <el-table-column label="操作"
                       width="110">
        <template slot-scope="{row}">
          <!-- <el-button type="text" v-if="staffProductDataScope === 1 && row.isAdmin === 0"
                     @click="setstaffproducts(row)">商品范围</el-button> -->
          <el-button type="text" v-if="row.isAdmin === 0"
                     @click="edititem(row)">编辑</el-button>
          <!-- <el-button type="text"
                     v-if="row.isAdmin === 0"
                     @click="deleteitem(row)">删除</el-button>
          <el-button type="text"
                     v-if="row.isAdmin === 0"
                     @click="resetpassword(row)">重置密码</el-button> -->
          <el-dropdown v-if="row.isAdmin === 0">
            <el-button type="text" style="margin-left: 10px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="staffProductDataScope === 1" @click.native="setstaffproducts(row)">商品范围</el-dropdown-item>
              <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="resetpassword(row)">重置密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <edit-staff-modal :callback="getstaffs"
                      ref="staff" />
    <product-set-modal :callback="getstaffs" ref="set" />
  </layout-card-wrap>
</template>

<script>
import EditStaffModal from './edit-staff-modal'
import ProductSetModal from './product-set-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'staff-table',
  components: { EditStaffModal, ProductSetModal },
  props: {
    staffProductDataScope: {
      type: Number,
      default: 0
    },
    callback: Function
  },
  data () {
    return {
      loading: false,
      list: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    resetpassword (row) {
      this.$confirm('此操作将重置密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('common/resetpassword', {
            payload: {
              account: row.account
            },
            success: res => {
              this.getstaffs()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    setstaffproducts (row) {
      this.$refs.set.fetch(row)
    },
    changeDataScope (open) {
      console.log(open)
      this.$confirm(`此操作${open === 1 ? '启用' : '禁用'}该设置, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('staff/configstaffproductdatascope', {
          payload: {
            open: !!open
          },
          success: (res) => {
            this.loading = false
            this.callback && this.callback()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    additem () {
      this.$refs.staff.init({}, 'add')
    },
    deleteitem (row) {
      this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('staff/deletestaff', {
            payload: {
              staffId: row.staffId
            },
            success: (res) => {
              this.loading = false
              this.getstaffs()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    edititem (row) {
      this.$refs.staff.init(row, 'update')
    },
    getstaffs () {
      this.loading = true
      this.$store.dispatch(`staff/getstaffs`, {
        payload: {
          vendorId: this.$route.query.vendorId,
          // orgId: 100,
          pageNum: 1,
          pageSize: 100000
        },
        success: (res) => {
          this.loading = false
          this.list = res.data.records.map(i => {
            i.functions = i.functions.map(s => s.funcId)
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.getstaffs()
  }
}
</script>
